export default "__VITE_ASSET__Bao1Lua3__"